import { useNavigate, useParams } from "react-router-dom";
import QuizBlueprintForm from "../../components/quizBlueprint/QuizBlueprintForm";


const CreateQuizBlueprint = () => {

    const { quizId } = useParams();

    const navigate = useNavigate();


    return (
        <QuizBlueprintForm
            quizId={quizId}
            mode="create"
            onSuccess={() =>
                navigate(`/quizzes/${quizId}`)
            }
        />
    );

};


export default CreateQuizBlueprint;